import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=4d4c7d34&"
import script from "./blank.vue?vue&type=script&lang=js&"
export * from "./blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports